<template>
  <div class="an-funnel">
    <div v-for="step in steps" :key="step.id" class="an-funnel__step">
      <div class="an-funnel__head">
        <span class="an-funnel__label" :title="'Событие: ' + step.event">{{ step.label }}</span>
        <span class="an-funnel__count">{{ step.count }}</span>
      </div>
      <div class="an-funnel__track">
        <div class="an-funnel__bar" :style="{ width: step.width }"></div>
      </div>
      <div class="an-funnel__meta">
        <span>{{ step.fromStart }} от первого шага</span>
        <span v-if="step.fromPrev">· {{ step.fromPrev }} от предыдущего</span>
        <span v-if="step.median">· медиана {{ step.median }}</span>
        <span v-if="step.delta" class="an-change" :class="step.delta.direction && 'an-change--' + step.delta.direction">
          {{ step.delta.text }} к прошлому периоду
        </span>
      </div>
    </div>
    <p class="an-funnel__note">Дошедшим считается тот, кто прошёл шаги по порядку за {{ window }}.</p>
  </div>
</template>

<script>
import {formatCount} from "@/common/rumFormat";
import {formatDelta, formatDuration, formatShare} from "@/common/viewFormat";

export default {
  name: "ViewFunnel",
  props: {
    funnel: {type: Object, required: true},
  },
  computed: {
    steps() {
      return (this.funnel.steps || []).map((s, i) => ({
        id: s.id,
        label: s.label,
        event: s.event,
        count: formatCount(s.count),
        // Полоса не короче 2%: нулевой шаг должен быть виден как «пусто», а не исчезать.
        width: `${Math.max(2, Math.min(100, (s.fromStart || 0) * 100))}%`,
        fromStart: formatShare(s.fromStart),
        fromPrev: i > 0 ? formatShare(s.fromPrev) : '',
        median: i > 0 && s.medianSec ? formatDuration(s.medianSec) : '',
        // У первого шага всегда 100% — сравнивать нечего.
        delta: i > 0 && s.prevFromStart !== undefined && s.prevFromStart !== null
            ? formatDelta(s.fromStart * 100, s.prevFromStart * 100, {unit: '%'})
            : null,
      }))
    },
    window() {
      const sec = this.funnel.window || 0
      if (sec === 86400) return 'сутки'
      if (sec % 86400 === 0 && sec > 0) return `${sec / 86400} дн.`
      return formatDuration(sec)
    },
  },
}
</script>
